var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { autoinject } from 'aurelia-dependency-injection';
import { NotificationClientService } from '../../../../../services/basics/notification-client.service';
import { I18N } from 'aurelia-i18n';
import { StepEnum, WidgetNames } from '../../../../../models/modules/lotteryplatofrm.models';
import { BrandingPreviewBase } from '../../branding/branding-preview-base';
import { EventAggregator } from 'aurelia-event-aggregator';
import { TokenClient } from '../../../../../services/authentication/token-client.service';
import { LookupClientService } from '../../../../../services/lookups/lookup-client.service';
import { DialogClientService } from '../../../../../services/basics/dialog-client.service';
import { BrandClientService, TemplateType } from '../../../../../services/modules/brand-client.service';
import { AttachmentClientService } from '../../../../../services/modules/attachements-client.service';
import { CacheClient } from '../../../../../services/basics/client-caching.service';
import * as Enumerable from "linq";
import { WidgetBrandingText } from './widget-steps/widget-branding-text';
import { WidgetBrandingImages } from './widget-steps/widget-branding-images';
import { WidgetBrandingColors } from './widget-steps/widget-branding-colors';
import { LotteryClientService } from '../../../../../services/modules/lottery-client.service';
import { WidgetLotterySelectBranding } from './widget-steps/widget-lottery-select-branding';
import { BindingSignaler } from 'aurelia-templating-resources';
import { WidgetBrandingConfig } from './widget-steps/widget-branding-config';
import { ClientLotteryClientService } from '../../../../../services/modules/client/client-lottery-client-service';
import { JsonLockClientService } from '../../../../../services/modules/json-lock-client-service';
var WidgetBrandingDialog = /** @class */ (function (_super) {
    __extends(WidgetBrandingDialog, _super);
    function WidgetBrandingDialog(element, notificationService, i18N, eventAggregator, brandClientService, attachmentClientService, widgetBrandingText, widgetBrandingImages, widgetLotterySelectBranding, widgetBrandingConfig, bindingSignaler, widgetBrandingColors, cacheClient, lotteryClientService, clientLotteryService, tokenClientService, lookupClientService, dialogClientService, jsonLockClientService) {
        var _this = _super.call(this, element, notificationService, i18N, eventAggregator, tokenClientService, lookupClientService, dialogClientService, brandClientService, attachmentClientService, cacheClient, jsonLockClientService) || this;
        _this.widgetBrandingText = widgetBrandingText;
        _this.widgetBrandingImages = widgetBrandingImages;
        _this.widgetLotterySelectBranding = widgetLotterySelectBranding;
        _this.widgetBrandingConfig = widgetBrandingConfig;
        _this.bindingSignaler = bindingSignaler;
        _this.widgetBrandingColors = widgetBrandingColors;
        _this.lotteryClientService = lotteryClientService;
        _this.clientLotteryService = clientLotteryService;
        _this.steps = [
            {
                step: 1,
                title: "Lotteries",
                view: null,
                show: true
            },
            {
                step: 2,
                title: "Bundles",
                view: null,
                show: true
            }
        ];
        _this._currentStep = _this.steps[0];
        return _this;
    }
    WidgetBrandingDialog.prototype.getFilesToSave = function () {
        return [TemplateType.Assets];
    };
    WidgetBrandingDialog.prototype.loadTemplate = function (templateName, themeName) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _super.prototype.loadTemplate.call(this, templateName, themeName)];
                    case 1:
                        _a.sent();
                        this.bindingSignaler.signal("refresh-item");
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(WidgetBrandingDialog.prototype, "selectedLottery", {
        get: function () { return this._selectedLottery; },
        set: function (x) {
            this._selectedLottery = x;
            this.rebindBrandingModel();
            this.reloadPreview();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WidgetBrandingDialog.prototype, "selectedBundle", {
        get: function () { return this._selectedBundle; },
        set: function (x) {
            this._selectedBundle = x;
            this.rebindBrandingModel();
            this.reloadPreview();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WidgetBrandingDialog.prototype, "currentStep", {
        get: function () { return this._currentStep; },
        set: function (x) {
            this._currentStep = x;
            this.rebindBrandingModel();
            this.reloadPreview();
        },
        enumerable: false,
        configurable: true
    });
    WidgetBrandingDialog.prototype.onActivated = function () {
        var _this = this;
        _super.prototype.onActivated.call(this);
        this.lotteryClientService.getLotteriesByBrand(this.isManagingDefaultConfig() ? null : this.item.brandId, this.isManagingDefaultConfig()).then(function (x) {
            _this.lotteries = Enumerable.from(x).select(function (a) { return a.lottery; }).toArray();
            _this._selectedLottery = _this.lotteries[0];
        });
        this.lotteryClientService.getBundlesByBrand(this.item.brandId).then(function (x) {
            _this.bundles = x;
            _this._selectedBundle = _this.bundles[0];
        });
    };
    WidgetBrandingDialog.prototype.reloadPreview = function (changeUri, force) {
        if (changeUri === void 0) { changeUri = null; }
        if (force === void 0) { force = false; }
        // super admin controls all brands config not a specific brand
        var brand = this.isManagingDefaultConfig() ? null : this.getBrandDetails();
        if (this.lang && this.brandingModel && this.brandingModel.themeName && this.brandingModel.templateName) {
            var brandParameter = brand && brand.brandId ? "&brandId=".concat(brand.brandId) : "";
            var href = this.buildRouteToNavigate(brandParameter, changeUri);
            if (href == this.routeToNavigate && !force)
                return; //no need to reload since URL didn't have any changes 
            this.routeToNavigate = href;
            var parent = document.getElementById("preview-".concat(this.id));
            if (parent.children.length > 0) {
                for (var i = parent.children.length - 1; i >= 0; i--)
                    parent.removeChild(parent.children.item(i));
            }
            var iframe = document.createElement('iframe');
            iframe.src = href;
            var width = this.getWidgetWidth();
            var height = this.getWidgetHeight();
            iframe.style.cssText = "width: ".concat(width, "px; height: ").concat(height, "px; border: 0;");
            iframe.className = 'bio-mp-screen';
            parent.appendChild(iframe);
        }
    };
    WidgetBrandingDialog.prototype.getWidgetWidth = function () {
        if (this.templateName == WidgetNames.ResultsWidget1)
            return 1065;
        if (this.templateName == WidgetNames.StandardWidget1)
            return 480;
        if (this.templateName == WidgetNames.StandardWidget2)
            return 690;
        return 0;
    };
    WidgetBrandingDialog.prototype.getWidgetHeight = function () {
        if (this.templateName == WidgetNames.ResultsWidget1)
            return 730;
        if (this.templateName == WidgetNames.StandardWidget1)
            return 280;
        if (this.templateName == WidgetNames.StandardWidget2)
            return 120;
        return 0;
    };
    Object.defineProperty(WidgetBrandingDialog.prototype, "showLottery", {
        get: function () {
            return this.templateName != WidgetNames.ResultsWidget1;
        },
        enumerable: false,
        configurable: true
    });
    WidgetBrandingDialog.prototype.getRouteAdditionalData = function () {
        if (this.showLottery) {
            if (this.currentStep.step == 1)
                return "lotteryName=".concat(this.selectedLottery.name);
            if (this.currentStep.step == 2)
                return "bundleName=".concat(this.selectedBundle.name);
        }
        return null;
    };
    WidgetBrandingDialog.prototype.getLotteryKey = function () {
        if (this.showLottery) {
            if (this.currentStep.step == 1)
                return this.selectedLottery.name;
            if (this.currentStep.step == 2)
                return this.selectedBundle.name;
        }
        return null;
    };
    WidgetBrandingDialog.prototype.getBrandTemplateInternalName = function () {
        return this.item.template.internalName;
    };
    WidgetBrandingDialog.prototype.getBrandThemeInternalName = function () {
        return this.item.brandTheme ? this.item.brandTheme.internalName : null;
    };
    WidgetBrandingDialog.prototype.getBrandingSteps = function () {
        var _this = this;
        return [{
                title: this.i18N.tr('widget'),
                step: StepEnum.LobbyBranding,
                show: true,
                view: "",
                children: [
                    {
                        title: "Lotteries",
                        vm: this.widgetLotterySelectBranding,
                        show: function () { return _this.templateName == WidgetNames.ResultsWidget1; },
                        view: '../../app/admin/brand/dialogs/widget-steps/widget-lottery-select-branding.html'
                    },
                    {
                        title: this.i18N.tr("widget-branding-text"),
                        vm: this.widgetBrandingText,
                        show: true,
                        view: '../../app/admin/brand/dialogs/widget-steps/widget-branding-text.html'
                    },
                    {
                        title: this.i18N.tr("widget-branding-images"),
                        vm: this.widgetBrandingImages,
                        show: true,
                        view: '../../app/admin/brand/dialogs/widget-steps/widget-branding-images.html'
                    },
                    {
                        title: this.i18N.tr("widget-branding-colors"),
                        vm: this.widgetBrandingColors,
                        show: true,
                        view: '../../app/admin/brand/dialogs/widget-steps/widget-branding-colors.html'
                    },
                    {
                        title: this.i18N.tr("widget-branding-config"),
                        vm: this.widgetBrandingConfig,
                        show: true,
                        view: '../../app/admin/brand/dialogs/widget-steps/widget-branding-config.html'
                    }
                ]
            }];
    };
    WidgetBrandingDialog.prototype.getBrandDetails = function () {
        return {
            brandId: this.item.brandId,
            brandName: this.item.name,
            brandLanguages: Enumerable.from(this.item.brandLanguages).select(function (x) { return x.languageId; }).toArray()
        };
    };
    WidgetBrandingDialog.prototype.getRoute = function () {
        return "";
    };
    WidgetBrandingDialog.prototype.isWidget = function () {
        return true;
    };
    WidgetBrandingDialog.prototype.getImages = function () {
        var items = [
            this.widgetBrandingImages.model
        ].concat(this.widgetLotterySelectBranding.model ? this.widgetLotterySelectBranding.model.map(function (x) { return x.image; }) : []);
        return items;
    };
    WidgetBrandingDialog = __decorate([
        autoinject,
        __metadata("design:paramtypes", [Element, NotificationClientService, I18N, EventAggregator, BrandClientService, AttachmentClientService,
            WidgetBrandingText,
            WidgetBrandingImages,
            WidgetLotterySelectBranding,
            WidgetBrandingConfig,
            BindingSignaler,
            WidgetBrandingColors,
            CacheClient, LotteryClientService, ClientLotteryClientService,
            TokenClient, LookupClientService, DialogClientService, JsonLockClientService])
    ], WidgetBrandingDialog);
    return WidgetBrandingDialog;
}(BrandingPreviewBase));
export { WidgetBrandingDialog };
